const css = `.tickets-list-skeleton {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}
.tickets-list-skeleton .ticket-item-skeleton {
  padding: 16px;
  border: 1px solid var(--surface-200);
  border-radius: 8px;
}
.tickets-list-skeleton .ticket-item-skeleton .ticket-header-skeleton {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 12px;
}
.tickets-list-skeleton .ticket-item-skeleton .ticket-header-skeleton .ticket-title-skeleton {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  padding-left: 8px;
  min-width: 0;
}
.tickets-list-skeleton .ticket-item-skeleton .ticket-header-skeleton .ticket-title-skeleton .type-icon-skeleton {
  flex-shrink: 0;
}
.tickets-list-skeleton .ticket-item-skeleton .ticket-header-skeleton .ticket-title-skeleton .title-skeleton {
  flex: 1;
}
.tickets-list-skeleton .ticket-item-skeleton .ticket-header-skeleton .status-badge-skeleton {
  flex-shrink: 0;
  border-radius: 12px;
}
.tickets-list-skeleton .ticket-item-skeleton .ticket-meta-skeleton {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.tickets-list-skeleton .ticket-item-skeleton .ticket-meta-skeleton .meta-badge-skeleton {
  border-radius: 6px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL3BhZ2VzL1N1cHBvcnQvY29tcG9uZW50cyIsInNvdXJjZXMiOlsiVGlja2V0c0xpc3RTa2VsZXRvbi5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7O0FBR0Y7RUFDRTs7QUFJSjtFQUNFO0VBQ0E7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRSIsInNvdXJjZXNDb250ZW50IjpbIi50aWNrZXRzLWxpc3Qtc2tlbGV0b24ge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBnYXA6IDEycHg7XG4gIG1hcmdpbi10b3A6IDE2cHg7XG5cbiAgLnRpY2tldC1pdGVtLXNrZWxldG9uIHtcbiAgICBwYWRkaW5nOiAxNnB4O1xuICAgIGJvcmRlcjogMXB4IHNvbGlkIHZhcigtLXN1cmZhY2UtMjAwKTtcbiAgICBib3JkZXItcmFkaXVzOiA4cHg7XG5cbiAgICAudGlja2V0LWhlYWRlci1za2VsZXRvbiB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgICAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQ7XG4gICAgICBtYXJnaW4tYm90dG9tOiAxMnB4O1xuICAgICAgZ2FwOiAxMnB4O1xuXG4gICAgICAudGlja2V0LXRpdGxlLXNrZWxldG9uIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgZ2FwOiA4cHg7XG4gICAgICAgIGZsZXg6IDE7XG4gICAgICAgIHBhZGRpbmctbGVmdDogOHB4O1xuICAgICAgICBtaW4td2lkdGg6IDA7XG5cbiAgICAgICAgLnR5cGUtaWNvbi1za2VsZXRvbiB7XG4gICAgICAgICAgZmxleC1zaHJpbms6IDA7XG4gICAgICAgIH1cblxuICAgICAgICAudGl0bGUtc2tlbGV0b24ge1xuICAgICAgICAgIGZsZXg6IDE7XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgLnN0YXR1cy1iYWRnZS1za2VsZXRvbiB7XG4gICAgICAgIGZsZXgtc2hyaW5rOiAwO1xuICAgICAgICBib3JkZXItcmFkaXVzOiAxMnB4O1xuICAgICAgfVxuICAgIH1cblxuICAgIC50aWNrZXQtbWV0YS1za2VsZXRvbiB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZ2FwOiA4cHg7XG4gICAgICBmbGV4LXdyYXA6IHdyYXA7XG5cbiAgICAgIC5tZXRhLWJhZGdlLXNrZWxldG9uIHtcbiAgICAgICAgYm9yZGVyLXJhZGl1czogNnB4O1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
